<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Select Folder
</h1>

<form>
    <div mat-dialog-content>
        <!-- Display the site's folder tree. -->
        <div class="folder-tree-div">
            <app-folder-tree [site]="this.Site"
                             [(path)]="this.TreePath"
                             (nodeSelected)="this.onNodeSelected($event)"></app-folder-tree>
        </div>

        <!-- Display the selected folder, if any. -->
        <div class="selected-folder-path-div">
            <span class="selected-folder-path-label">Path:</span>

            <span class="selected-folder-path-span">{{this.SelectedFolderPath}}</span>
        </div>
    </div>

    <div mat-dialog-actions>
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="!this.SelectedFolderPath"
                (click)="this.selectPathClicked()">
            Select
        </button>

        <button mat-flat-button
                [mat-dialog-close]="null"
                style="margin-left: 10px;">
            Cancel
        </button>
    </div>
</form>
